module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ltium"))).then(() => parcelRequire('5p3pM'));